import { Base64Url } from './iabtcf/Base64Url';
export var decodePurposeOne = function (encodedTCString) {
    var segments = encodedTCString.split('.');
    // documentation says its always the first one for v2
    var coreSegment = segments[0];
    var bitField = Base64Url.decode(coreSegment);
    var purposeOneBit = bitField[152];
    return purposeOneBit === '1';
};
